const tagPattern = '{(?<tag>[^}{]+?)}'
export const getTagsRegexp = (flags = '') => new RegExp(tagPattern, flags)
